import React from "react"
import { createElement } from "./../utils/create-elements"

const Blog = ({ blok }) => {
  if (blok.body) {
    for (let i = 0; i < blok.body.length; i++) {
      blok.body[i] = {
        ...blok.body[i],
        is_blog_child: true,
        sort_by_date: blok.sort_by_date,
      }
    }
  }

  return (
    <>
      {createElement({
        ...blok,
      })}
    </>
  )
}

export default Blog
